import { render, staticRenderFns } from "./KasaDekontView.vue?vue&type=template&id=101477f2&"
import script from "./KasaDekontView.vue?vue&type=script&lang=js&"
export * from "./KasaDekontView.vue?vue&type=script&lang=js&"
import style0 from "./KasaDekontView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports